import React, { useEffect } from "react";
import { connect } from "react-redux";
import { MEApi, setHeading, setModuleKey } from "./account.actions";
import { DashboardDataApi } from "../forms/AccountsModule/AccountsDashboard/AccountsDashboardAction";
import { startFinancialDate, endFinancialDate } from "../../../global/globalFunctions";
import { Box, Grid, Card, CardContent, Typography, Avatar, } from "@mui/material";
import { Store, AccountBalance, ShoppingCart, Receipt, BarChart, People, Settings, Engineering } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import ConstructionIcon from '@mui/icons-material/Construction';
import SinglePageDashbord from "../drawer/SinglePageDashbord";
import ReceiptIcon from '@mui/icons-material/Receipt';
// import KitchenIcon from '@mui/icons-material/Kitchen';
// import TableRestaurantIcon from "@mui/icons-material/TableRestaurant";


const UserMainPage = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const permissions = JSON.parse(window.localStorage.getItem("permissions"))
  const userName = window.localStorage.getItem("userName") || "User";
  const modules = [
    {
      title: t("store"),
      permissionName: "Store",
      route: "/store",
      moduleKey: "storeList",
      icon: <Store />,
      color: "#2563EB",
    },
    {
      title: t("accounts"),
      permissionName: "Accounts",
      route: "/accountsModule",
      moduleKey: "accountsModule",
      icon: <AccountBalance />,
      color: "#14B8A6",
    },
    {
      title: t("salesOrder"),
      permissionName: "POS",
      route: "/pos-order",
      moduleKey: "salesOrderList",
      icon: <ShoppingCart />,
      color: "#F59E0B",
    },
    {
      title: t("orderView"),
      permissionName: "Order View",
      route: "/view-order",
      moduleKey: "salesOrderList",
      icon: <Receipt />,
      color: "#EF4444",
    },
    {
      title: t("reports"),
      permissionName: "Reports",
      route: "/report",
      moduleKey: "reportsList",
      icon: <BarChart />,
      color: "#8B5CF6",
    },
    {
      title: t("humanResources"),
      permissionName: "Human Resources",
      route: "/hr",
      moduleKey: "hr",
      icon: <People />,
      color: "#10B981",
    },
    {
      title: t("production"),
      permissionName: "Production",
      route: "/production",
      moduleKey: "production",
      icon: <Engineering />,
      color: "#0EA5E9",
    },
    {
      title: t("setting"),
      permissionName: "Setting",
      route: "/setting",
      moduleKey: "setting",
      icon: <Settings />,
      color: "#64748B",
    },
    {
      title: t("CRM"),
      permissionName: "CRM",
      route: "/crm",
      moduleKey: "crm",
      icon: <SupportAgentIcon />,
      color: "#16A34A",
    },
    {
      title: t("masterControl"),
      permissionName: "Master Control",
      route: "/inventory",
      moduleKey: "UserInventory",
      icon: <AdminPanelSettingsIcon />,
      color: "#7C3AED",
    },
    {
      title: t("construction"),
      permissionName: "Contruction Module",
      route: "/contruction",
      moduleKey: "constructionModule",
      icon: <ConstructionIcon />,
      color: "#d23aed",
    },
    // {
    //   title: t("FBRInvoice"),
    //   permissionName: "Contruction Module",
    //   route: "/fbr",
    //   moduleKey: "FBRInvoiceModule",
    //   icon: <ReceiptIcon />,
    //   color: "#EA580C",
    // },
    // {
    //   title: "Kitchen Display System",
    //   permissionName: "Master Control",
    //   route: "/kds",
    //   moduleKey: "kds",
    //   icon: <KitchenIcon />,
    //   color: "#EA580C",
    // },
    // {
    //   title: "Table Order",
    //   permissionName: "Master Control",
    //   route: "/table",
    //   moduleKey: "table",
    //   icon: <TableRestaurantIcon />,
    //   color: "#2563EB",
    // },
  ];

  const allowedModules = modules.filter((module) =>
    permissions?.some((p) => p.permissionsName === module.permissionName)
  );

  const handleClick = (module) => {
    setModuleKey(module.moduleKey);
    localStorage.setItem("module_key", module.moduleKey);
    props.setHeading(module.title);
    navigate(module.route);
  };

  useEffect(() => {
    props.DashboardDataApi({
      startDate: startFinancialDate,
      endDate: endFinancialDate,
    });
    props.MEApi();
  }, []);

  return (
    <>
      <SinglePageDashbord header='Home' />

      <Box sx={{ p: 4, background: "#F8FAFC", minHeight: "100vh" }}>
        <Typography variant="h5" fontWeight="bold" gutterBottom marginBottom={"25px"} textAlign="center">
          {`Welcome Back, ${userName} 👋`}
        </Typography>

        {/* <div className="text-4xl font-bold text-blue-600">
          Tailwind Working 🚀
        </div> */}

        <Grid container spacing={3}>
          {allowedModules.map((module, index) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
              <Card
                onClick={() => handleClick(module)}
                sx={{
                  borderRadius: 4,
                  boxShadow: "0 8px 20px rgba(0,0,0,0.05)",
                  transition: "all 0.3s ease",
                  cursor: "pointer",
                  "&:hover": {
                    transform: "translateY(-6px)",
                    boxShadow: "0 12px 30px rgba(0,0,0,0.1)",
                  },
                }}
              >
                <CardContent sx={{ textAlign: "center", py: 5 }}>
                  <Avatar
                    sx={{
                      bgcolor: module.color,
                      width: 80,
                      height: 80,
                      margin: "0 auto 16px",
                    }}
                  >
                    {React.cloneElement(module.icon, { sx: { fontSize: 45 } })}
                  </Avatar>

                  <Typography variant="h6" fontWeight="600">{module.title.toUpperCase()}</Typography>

                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    setModuleKey: (data) => dispatch(setModuleKey(data)),
    setHeading: (data) => dispatch(setHeading(data)),
    DashboardDataApi: (payload) => dispatch(DashboardDataApi(payload)),
    MEApi: () => dispatch(MEApi()),
  };
};
const mapStateToProps = (state, ownProps) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(UserMainPage);